import { BrandPlanScheduleContentStatus } from 'types'

export interface ContentsFilters {
  status?: BrandPlanScheduleContentStatus | BrandPlanScheduleContentStatus[]
}

export type SourceType = 'Website' | 'PlainText' | 'AlmanacFile' | 'SourceMaterialsMediaObject'

export interface SourcesFilters {
  sourceType?: SourceType[]
}

export interface MediaFilesFilters {
  items?: number
  order_by?: 'recent' | undefined
}

export const scheduleKeys = {
  all: ['schedules'] as const,
  lists: () => [...scheduleKeys.all, 'list'] as const,
  list: (filters: string) => [...scheduleKeys.lists(), { filters }] as const,
  details: () => [...scheduleKeys.all, 'detail'] as const,
  detail: (id: number) => [...scheduleKeys.details(), id] as const,
  pending: (workspaceId: number) => [...scheduleKeys.all, workspaceId, 'pending'] as const,
  contents: (scheduleId: number, filters?: ContentsFilters, items?: number) =>
    filters !== undefined || items !== undefined
      ? ([...scheduleKeys.detail(scheduleId), 'contents', 'list', { filters, items }] as const)
      : ([...scheduleKeys.detail(scheduleId), 'contents', 'list'] as const),
  contentDetail: (scheduleId: number, contentId: number) =>
    [...scheduleKeys.detail(scheduleId), 'contents', 'detail', contentId] as const,
  referenceImage: (scheduleId: number, contentId: number) =>
    [...scheduleKeys.contentDetail(scheduleId, contentId), 'reference_image'] as const,
  activeBatch: (scheduleId: number) => [...scheduleKeys.detail(scheduleId), 'active_generation_batch'] as const,
  activeBatchId: (workspaceId: number) => [...scheduleKeys.all, workspaceId, 'active_batch_id'] as const,
  sources: (scheduleId: number, filters?: SourcesFilters) =>
    filters !== undefined
      ? ([...scheduleKeys.detail(scheduleId), 'sources', filters] as const)
      : ([...scheduleKeys.detail(scheduleId), 'sources'] as const),
  mediaFiles: (scheduleId: number, filters?: MediaFilesFilters) =>
    filters !== undefined
      ? ([...scheduleKeys.detail(scheduleId), 'media_files', 'list', filters] as const)
      : ([...scheduleKeys.detail(scheduleId), 'media_files', 'list'] as const),
}
